import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=e222987c&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=e222987c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e222987c",
  null
  
)

export default component.exports